var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"appear"}},[_c('div',{class:( _obj = {}, _obj[_vm.$style.loading] = true, _obj[_vm.$style.dark] = !_vm.light, _obj )},[_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }